import React, { FunctionComponent, useRef } from "react";
import { createPortal } from "react-dom";

import { FontWeight, Layout, SpacingSize, Text } from "@multiweb/reactComponents";
import { bemClassNames, invariant, useClickOutsideWatcher } from "@multiweb/reactUtils";
import { MODAL_ROOT_ID } from "../../../../../constants";
import { ActivityPoistionSearchResult } from "../../types";

export type SearchResultsModalProps = {
    readonly results: readonly ActivityPoistionSearchResult[];
    readonly left: number;
    readonly top: number;
    readonly onOuterSpaceClick: () => void;
    readonly onSearchResultClick: (setId: string, selectedActivityId: string) => void;
};

const classNames = bemClassNames("search-results-modal-component");
const modalClass = classNames();
const searchResultItemClass = classNames("search-result-item");

export const SearchResultsModal: FunctionComponent<SearchResultsModalProps> = ({ results, left, top, onSearchResultClick, onOuterSpaceClick }) => {
    const modalRoot = document.getElementById(MODAL_ROOT_ID);
    invariant(modalRoot, `[ModalWindow] Cannot render modal window because element with id ${MODAL_ROOT_ID} is undefined.`);

    const modalRef = useRef<HTMLDivElement>(null);
    useClickOutsideWatcher([ modalRef ], onOuterSpaceClick);

    return createPortal(
        <div ref={modalRef} className={modalClass} style={{ left, top }}>
            {results.map(({ setId, activityId, setName, activityName }) =>
                <div key={setId + activityId} onClick={() => onSearchResultClick(setId, activityId)} className={searchResultItemClass}>
                    <Text fontWeight={FontWeight.bold} value={activityName} />
                    <Layout spacingSizeLeft={SpacingSize.xxs} />
                    <Text value={`(${setName})`} />
                </div>,
            )}
        </div>, modalRoot);
};
